import { API_CALLS } from "@/services/apis/index.js";

export default {
  getProductsWholeSales(context, data) {
    console.log(data);
    return new Promise((resolve, reject) => {
      API_CALLS.FilterWHProducts(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDropdownsWholeSales() {
    return new Promise((resolve, reject) => {
      API_CALLS.getWHDropDowns()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createProduct(context , data) {
    console.log("inside create store =>" , JSON.stringify(data))
    return new Promise((resolve, reject) => {
      API_CALLS.CreateWHProduct(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateTitle(context , data) {
    return new Promise((resolve, reject) => {
      API_CALLS.updateTitle(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateWHProduct(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.updatedProduct(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  ExportWHProduct(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.ExportWHProductAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};
